import { createReducer, on } from '@ngrx/store';
import { CloseDrawer, OpenDrawer, SetDrawerWidth, ToggleDrawer } from '../actions/drawer.actions';

export const DRAWER_MIN_WIDTH = 400;

export interface DrawerState {
  isOpen: boolean;
  width: number;
}

const initialState: DrawerState = {
  isOpen: false,
  width: DRAWER_MIN_WIDTH,
};

export const DrawerReducer = createReducer(
  initialState,
  on(OpenDrawer, (state) => ({
    ...state,
    isOpen: true,
  })),
  on(CloseDrawer, (state) => ({
    ...state,
    isOpen: false,
  })),
  on(ToggleDrawer, (state) => ({
    ...state,
    isOpen: !state.isOpen,
  })),
  on(SetDrawerWidth, (state, { width }) => ({
    ...state,
    width: Math.max(width, DRAWER_MIN_WIDTH),
  })),
);
